import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

import './index.less'

let iconPopup: any = null
const IconPopup = forwardRef((props: any, ref: any) => {
  const { popupData } = props

  const [objData, setObjData] = useState<any>({})
  useImperativeHandle(ref, () => ({
    handleSetStyle,
  }))

  useEffect(() => {
    iconPopup = document.getElementById('icon-popup')
    setObjData(popupData)
    showPopup()
  }, [popupData])

  const showPopup = () => {
    if (iconPopup) {
      iconPopup.style.display = 'block'
    }
  }

  const handleSetStyle = (data: any) => {
    iconPopup.style.left = `${data.sx}px`
    iconPopup.style.top = `${data.sy}px`
  }

  return (
    <div>
      <div
        id="icon-popup"
        style={{
          display: 'block',
          top: objData ? objData.sy : 0,
          left: objData ? objData.sx : 0,
        }}>
        <div className="head">
          <div className="name">
            {objData.hsptlSeCdNm
              ? objData.hsptlSeCdNm
              : '' || objData.schoolNm
                ? objData.schoolNm
                : ''
                  || objData.fcltyNm
                  ? objData.fcltyNm
                  : '' || objData.exprnNm
                    ? objData.exprnNm
                    : '' || objData.styiNm
                      ? objData.styiNm
                      : ''
                        || objData.nodeNm
                        ? objData.nodeNm
                        : '' || objData.bofficeNm
                          ? objData.bofficeNm
                          : '' || objData.prkplceTypeCdNm
                            ? `${objData.prkplceTypeCdNm}주차장`
                            : '' || objData.bizesNm
                              ? objData.bizesNm
                              : '' || objData.mrktNm
                                ? objData.mrktNm
                                : ''}</div>
          <div className="addr">
            {objData.addr
              ? objData.addr
              : '' || objData.rdnmadr
                ? objData.rdnmadr
                : ''
                  || objData.rnAdres
                  ? objData.rnAdres
                  : '' || objData.adres
                    ? objData.adres
                    : '' || objData.exprnAddr
                      ? objData.exprnAddr
                      : ''
                        || objData.rteNm
                        ? objData.rteNm
                        : '' || objData.rdnmAdr
                          ? objData.rdnmAdr
                          : '' || objData.roadNmAddr
                            ? objData.roadNmAddr
                            : ''}</div>
        </div>
      </div>
    </div>
  )
})

export default IconPopup
